import { __awaiter } from 'tslib';
import md5 from 'js-md5';
import { ContextClassBase, ServiceIdentity } from '../../core/service/RuntimeContext.js';
import 'long';
import { im_proto } from '../../proto/index.js';
import { SdkConsts, ErrorType } from '../../core/consts.js';
import '../../core/metrics/logger.js';
import { BaseError } from '../../core/errors/BaseError.js';
import { Monitor, MonitorItem } from '../../core/metrics/monitor.js';
import '../../core/network/NetworkItem.js';
import { Subject } from '../../core/events/Subject.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../manager/AdapterManager.js';
import '../manager/types.js';
import '../../core/utils/ticker.js';
import './IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

function stringify(obj) {
    const strArray = [];
    for (const field of Object.keys(obj)) {
        if (obj[field] !== undefined && obj[field] !== '') {
            strArray.push(`${field}=${obj[field]}`);
        }
    }
    return strArray.join('&');
}
class IMWebSocket extends ContextClassBase {
    constructor(ctx) {
        super(ctx); // bind context later
        this.openTime = 0;
        this.createTime = 0;
        this.option = ctx.option;
        this.url = this.option.frontierUrl;
        this.onClose = new Subject(ctx);
        this.onOpen = new Subject(ctx);
        this.onError = new Subject(ctx);
        this.onMessage = new Subject(ctx);
        this.onOpen.subscribe(() => {
            var _a;
            this.openTime = Monitor.performanceNow();
            this.resolve(ServiceIdentity.Monitor).emitMetrics(MonitorItem.FrontierOpen, {
                duration: this.openTime - this.createTime
            }, {
                url: (_a = this.url) !== null && _a !== void 0 ? _a : 'unknown'
            });
        });
        this.onClose.subscribe(event => {
            var _a, _b, _c, _d;
            if (typeof CloseEvent !== 'undefined' && event instanceof CloseEvent) {
                this.resolve(ServiceIdentity.Monitor).emitMetrics(MonitorItem.FrontierClose, {
                    count: 1
                }, {
                    url: (_a = this.url) !== null && _a !== void 0 ? _a : 'unknown',
                    code: (_b = event.code) === null || _b === void 0 ? void 0 : _b.toString(),
                    reason: event.reason
                });
            }
            else {
                this.resolve(ServiceIdentity.Monitor).emitMetrics(MonitorItem.FrontierClose, {
                    count: 1
                }, {
                    url: (_c = this.url) !== null && _c !== void 0 ? _c : 'unknown'
                });
            }
            if (this.openTime !== 0 && !Number.isNaN(this.openTime)) {
                this.resolve(ServiceIdentity.Monitor).emitMetrics(MonitorItem.FrontierLive, {
                    duration: Monitor.performanceNow() - this.openTime
                }, {
                    url: (_d = this.url) !== null && _d !== void 0 ? _d : 'unknown'
                });
            }
            this.openTime = 0;
        });
        this.onMessage.subscribe((frame) => {
            var _a;
            if (frame.toString() === 'hi') {
                return;
            }
            this.resolve(ServiceIdentity.Monitor).emitMetrics(MonitorItem.FrontierReceive, {
                count: 1
            }, {
                url: (_a = this.url) !== null && _a !== void 0 ? _a : 'unknown'
            });
        });
        this.onError.subscribe(() => {
            var _a;
            this.resolve(ServiceIdentity.Monitor).emitMetrics(MonitorItem.FrontierError, {
                count: 1
            }, {
                url: (_a = this.url) !== null && _a !== void 0 ? _a : 'unknown'
            });
        });
    }
    get paramUrl() {
        var _a, _b;
        const env = ((_b = (_a = this.option) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b[SdkConsts.envKey]) !== undefined ?
            { [SdkConsts.envKey.toLowerCase()]: this.option.headers[SdkConsts.envKey] } :
            {};
        const options = Object.assign(Object.assign({ token: this.ctx.cachedToken, sid: this.option.sessionId, aid: this.option.appId, fpid: this.option.fpId, device_id: this.option.deviceId, 
            // @ts-ignore
            access_key: md5(`${this.option.fpId + this.option.appKey + this.option.deviceId}f8a69f1719916z`), device_platform: this.option.devicePlatform, version_code: this.option.versionCode }, this.option.extended), env);
        if (this.ctx.option.authType === im_proto.AuthType.CERT_AUTH) {
            const auth = this.resolve(ServiceIdentity.AuthManager);
            options.sdk_cert = encodeURIComponent(auth.getCert());
            options.ts_sign = encodeURIComponent(auth.getTsSign());
        }
        return `${this.url}?${stringify(options)}`;
    }
    // 带超时
    performOpen() {
        let resolved = false;
        this.createTime = Monitor.performanceNow();
        const racePromise = new Promise((_, reject) => {
            setTimeout(() => {
                if (resolved) {
                    return;
                }
                reject(new BaseError({
                    ctx: this.ctx,
                    msg: 'frontier connect timeout',
                    type: ErrorType.NetworkError,
                    sender: this
                }));
            }, this.ctx.option.timeout);
        });
        const connectPromise = () => __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.open();
            }
            catch (err) {
                throw new BaseError({
                    ctx: this.ctx,
                    msg: 'ws connect error',
                    innerError: err,
                    sender: this,
                    type: ErrorType.NetworkError
                });
            }
            finally {
                resolved = true;
            }
        });
        return Promise.race([racePromise, connectPromise()]);
    }
    dispose() {
        this.onOpen.unsubscribeAll();
        this.onClose.unsubscribeAll();
        this.onError.unsubscribeAll();
        this.onMessage.unsubscribeAll();
    }
}

export { IMWebSocket };
//# sourceMappingURL=IMWebSocket.js.map
